// DS: C35
import React from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import { getDeviationTitle } from '../../../DeviationViews/_helpers';
import UserAvatar from '../../../User/Avatar';
import Stats from '../../../Stats';
import CoreBadgeList from '../../../coreBadge/CoreBadgeList';
import { isLongTitle } from '../../helpers';
import Author from '../../_partials/Author';
import GroupDetail from '../../_partials/GroupDetail';
import Title from '../../_partials/Title';
import PremiumIndicator from '../../_partials/PremiumIndicator';
import s from './DesktopSubmissionDetails.scss';
var DesktopSubmissionDetails = function (_a) {
    var className = _a.className, deviation = _a.deviation, _b = _a.deviation, author = _b.author, poll = _b.poll, _c = _b.extended, extended = _c === void 0 ? {} : _c, isOwner = _a.isOwner, showTitle = _a.showTitle;
    var exclusiveGroup = extended.exclusiveGroup, originalAuthor = extended.originalAuthor;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var deviationTitle = getDeviationTitle(deviation);
    var hasTitle = deviationTitle && showTitle;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        React.createElement(BiLoggerContextProvider, { value: { sectionname: 'author' } },
            author && (React.createElement(UserAvatar, { withTooltip: true, relatedItemBiData: {
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId,
                }, size: 50, user: exclusiveGroup || author, className: s['avatar'] })),
            React.createElement("div", { className: s['upper-row'] },
                hasTitle && (React.createElement("div", { className: s['title-row'] },
                    React.createElement(PremiumIndicator, { deviation: deviation, className: classnames(s['premium-indicator'], isLongTitle(deviationTitle)
                            ? s['folder-icon-long-title']
                            : undefined) }),
                    React.createElement(Title, { title: deviationTitle, showTitle: showTitle, className: s['title'] }))),
                React.createElement(CoreBadgeList, { className: s['badges'], deviation: deviation })),
            React.createElement("div", { className: s['lower-row'] },
                React.createElement("div", { className: s['group-author'] },
                    exclusiveGroup && (React.createElement(GroupDetail, { className: s['group-detail'], group: extended.exclusiveGroup })),
                    React.createElement(Author, { author: originalAuthor || author, isOwner: isOwner, className: classnames(s['author'], originalAuthor && s['original-author']) })),
                isExtendedLoaded && !poll && (React.createElement(Stats, { className: s['stats'], deviation: deviation, withBadges: false }))))));
};
DesktopSubmissionDetails.displayName = 'DesktopSubmissionDetails';
export default DesktopSubmissionDetails;
//# sourceMappingURL=DesktopSubmissionDetails.js.map